"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateMixin = exports.truncateChildrenMixin = exports.textAlignMixin = exports.hiddenButReaderAccessibleMixin = exports.fontWeightMixin = void 0;
var _styledComponents = require("styled-components");
var textAlignMixin = (0, _styledComponents.css)(["", ";"], function (props) {
  return props.textAlign && (0, _styledComponents.css)(["text-align:", ";"], props.textAlign);
});
exports.textAlignMixin = textAlignMixin;
var fontWeightMixin = (0, _styledComponents.css)(["", ";"], function (props) {
  return props.fontWeight && (0, _styledComponents.css)(["font-weight:", ";"], props.theme.fontWeights[props.fontWeight] || "inherit");
});
exports.fontWeightMixin = fontWeightMixin;
var hiddenButReaderAccessibleMixin = (0, _styledComponents.css)(["border:0;clip:rect(1px,1px,1px,1px);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute !important;width:1px;word-wrap:normal !important;"]);
exports.hiddenButReaderAccessibleMixin = hiddenButReaderAccessibleMixin;
var truncateMixin = (0, _styledComponents.css)(["", ""], function (props) {
  return props.truncate && (0, _styledComponents.css)(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
});
exports.truncateMixin = truncateMixin;
var truncateChildrenMixin = (0, _styledComponents.css)(["", ""], function (props) {
  return props.truncateChildren && (0, _styledComponents.css)(["flex:1;min-width:0;& > *{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"]);
});
exports.truncateChildrenMixin = truncateChildrenMixin;